
export interface IErrorInfo {
    code: string;
}

export class ErrorInfo implements IErrorInfo {
    constructor(public code: string) { }
}
